import { render, staticRenderFns } from "./RawMaterialGroupsTable.vue?vue&type=template&id=005c9f31"
import script from "./RawMaterialGroupsTable.vue?vue&type=script&lang=ts"
export * from "./RawMaterialGroupsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports